<template>
  <el-container style="position: fixed; top: 0;z-index: 500;">
    <el-header class="changeWhite">
      <!--        <div class="headerBox">-->
      <router-link to="/">
        <img src="../assets/images/logo.png" alt=""
             style="position: fixed; height: 8vh;width: 11vh; left: 6vh; top: 0.8vh; z-index: 60">
      </router-link>
      <!--        <img :src="titleImg" alt=" " height="75px" style="position: fixed; height: 75px; left: 150px">-->
      <el-menu
          :default-active="activeIndex"
          mode="horizontal"
          background-color="#00000000"
          :text-color="navColor"
          :active-text-color="navColor1"
          router
          class="el-menu1"
          style="color:#ffd04b !important;"
      >
        <!-- <el-menu-item style="width:230px;"><el-icon :size="40" ><edit /></el-icon>本体模型(第一轮)</el-menu-item> -->
        <el-menu-item :index='"/project/"+this.project_id+"/mark/case/firstMark"' style="width: 8%"><el-icon :size="40"><edit /></el-icon><span style="font-size: 20px;">Pre Annotation</span></el-menu-item>
        <el-menu-item :index='"/project/"+this.project_id+"/mark/case/secondMark"' style="width: 10%"><el-icon :size="40"><edit /></el-icon><span style="font-size: 20px;">Batch Annotation</span></el-menu-item>

        <el-menu-item :index='"/project/"+this.project_id+"/premark/dataset"' style="width: 10%"><el-icon :size="40" ><Setting /></el-icon><span style="font-size: 20px;">Data/Settings</span></el-menu-item>
        <el-menu-item style="position:fixed;right:20vw" index="/" @click="logout"><el-icon :size="40" ><SwitchButton /></el-icon>Log out</el-menu-item>
      </el-menu>

      <!-- <el-dropdown style="position: fixed; z-index: 60; right: 10vw;margin-top: 8vh; margin-right: 1vw">
        <el-avatar style="position: fixed; z-index: 60; right: 10vw;top: 3vh;" shape="square" size="large"
                :style="{'background-image':'url(' +squareUrl+')', 'background-size': '100%'}"
                @click="callLogin()"></el-avatar>
        <template #dropdown style="top: 7vh">
          <el-dropdown-menu>
            <el-dropdown-item divided v-if="this.isLogin" @click="logout()" style="text-align: center;">
              Log out登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown> -->
      <!--        </div>-->
    </el-header>
    <!-- <el-aside>
			<el-input
				v-model="searchFile"
				placeholder="搜索文档"
				class="search-file-input"
			>
				<template #prepend>
					<el-select v-model="searchCriteria" style="width: 115px;">
						<el-option label="All" value="1" />
						<el-option label="Active" value="2" />
						<el-option label="Completed" value="3" />
					</el-select>
				</template>
			</el-input>
			<div style="color: white; margin: 30px 0 0 30px;">共有{{  }}条待标注数据</div>
    </el-aside> -->
  </el-container>
</template>

<script>
import {ref} from "vue";
import router from "../router";
import axios from 'axios';
export default {
    data(){
			return{
				isLogin: false,
				navColor: '#000000',
				navColor1: '#ffd04b',
				squareUrl: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
				activeIndex: ref(this.$route.path),
        icon: require('../assets/images/icon.svg'),
				searchFile: '',
				searchCriteria: '1',
        csrfToken:"",
			}
    },
    created(){
      var url = window.location.href
      var begin = url.indexOf('/project/') + 9
      var end = url.indexOf('/mark')
      this.project_id = url.slice(begin, end)
      var strcookie = document.cookie;//获取cookie字符串
      var arrcookie = strcookie.split("; ");//分割
      //遍历匹配
      for ( var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == "csrftoken"){
          this.csrfToken = arr[1];
        }
      }
    },
    mounted() {
    },
    methods: {
      callLogin() {
        this.$router.push({name:'Login'})
      },
      logout(){
        axios({
          method: 'get',
          url: '/api/logout/',
          headers:{
            'X-CSRFToken': this.csrfToken,
          },
        }).then(response => {
          if (response.status == 200) { // 已经为登录状态
            console.log("成功Log out")
            this.$Global.isLogin = false
            this.$router.push({name:'Login'})
          }
        }).catch(error=>{
          console.log('重复Log out')
        })
      },
    }
}
</script>

<style scoped>
.changeWhite {
  color: #131212;
  background: white;
  /* transition: 1.5s; */
  /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
  width: 100%;
  height: 10vh;
  position: fixed;
  z-index: 50;
}
.el-menu1 {
  position: fixed;
  width: 100%;
  left: 10vw;
  z-index: 60;
  height: 10vh;
}

.el-menu1 > * {
  height: 10vh;
  line-height: 10vh;
  width: 12vw;
  font-size: 1.4vw;
}

</style>
<style lang="scss">

.el-menu1 * {
  text-align: center;
}

// .el-aside{
//   background-color: #545c64;
// 	position: absolute;
// 	height: 100vh;
// 	width: 60vh;
// }
.el-input-group__prepend{
	height: 45px;
}
.el-input__inner{
	height: 45px;
}
</style>